// - LOGIN
export const CART = "CART";
export const CART_REMOVE = "CART_REMOVE";
export const CART_ADD = "CART_ADD";
export const CART_UPDATE = "CART_UPDATE";
export const CART_CLEAR = "CART_CLEAR";